enum ConditionOperator {
    EQUAL = 'eq',
    NOT_EQUAL = 'neq',
    LESS_THAN = 'lt',
    LESS_THAN_OR_EQUAL = 'lte',
    GREATER_THAN = 'gt',
    GREATER_THAN_OR_EQUAL = 'gte',
    CONTAINS_ALL_OF = 'all',
    CONTAINS_ANY_OF = 'any',
}

const CF_TYPE_OPERATORS: Record<string, ConditionOperator[]> = {
    'boolean': [ConditionOperator.EQUAL],
    'date': [ConditionOperator.LESS_THAN, ConditionOperator.GREATER_THAN],
    'select': [ConditionOperator.CONTAINS_ANY_OF],
    'checkbox': [ConditionOperator.CONTAINS_ALL_OF],
    'simple-text': [ConditionOperator.CONTAINS_ANY_OF],
    'numeric': [
        ConditionOperator.GREATER_THAN_OR_EQUAL,
        ConditionOperator.LESS_THAN,
        ConditionOperator.LESS_THAN_OR_EQUAL,
        ConditionOperator.EQUAL,
    ],
};

const SUPPORTED_CF_TYPES: string[] = [
    'boolean', 'date', 'select', 'checkbox', 'simple-text', 'rich-text', 'numeric',
];

// Define scopes for conditions to differentiate between object properties and custom fields.
enum ConditionScope {
    CUSTOM_FIELDS = 'custom_fields',
    OBJECT_PROPERTIES = 'object.properties',
}

// Maps property data types from template metadata to CF types for operator resolution.
const PROPERTY_TYPE_TO_CF_TYPE: Record<string, string> = {
    'number': 'numeric',
    'amount': 'numeric',
    'percent': 'numeric',
    'string': 'simple-text',
    'text': 'simple-text',
    'rich-text': 'simple-text',
    'textarea': 'simple-text',
    'date': 'date',
    'select': 'select',
    'boolean': 'boolean',
};

// Maps property group values to CF object types when they don't directly match.
// Properties with group "estimate" or "invoice" are custom fields of "document", etc.
// If a property group is not listed here, it is assumed to directly match a CF object type.
const PROPERTY_GROUP_TO_CF_OBJECT: Record<string, string> = {
    estimate: 'document',
    invoice: 'document',
    credit_note: 'document',
    delivery_form: 'document',
    order: 'document',
    proforma: 'document',
    purchase_order: 'document',
    supplier_invoice: 'document',
};

export {
    ConditionOperator,
    ConditionScope,
    CF_TYPE_OPERATORS,
    SUPPORTED_CF_TYPES,
    PROPERTY_TYPE_TO_CF_TYPE,
    PROPERTY_GROUP_TO_CF_OBJECT,
};
